import MaintenancePage from "../MaintenancePage";
import resource from "../../resources/employmentStatusResource";

export default function EmploymentStatus() {
    return <MaintenancePage resource={resource} />;
}
